module.exports = __webpack_public_path__ + "static/media/logo_shoppaworld.850e2327.svg";